/*
 * @Author: wjl
 * @Date: 2020-04-21 13:45:51
 * @LastEditors: wjl
 * @LastEditTime: 2020-09-04 11:56:27
 * @FilePath: \appOfficial\src\utils\ch.js
 */
module.exports = {
  bottomList: {
    0: { title: "关注我们", two: "微信", thre: "新浪微博" },
    1: {
      title: "加入我们",
      two: "社会招聘",
      thre: "校园招聘",
      for: "国际招聘",
    },
    2: { title: "联系我们", two: "客户服务", thre: "合作洽谈" },
  },
  bottomTxt: {
    0: "Copyright © 1998-2017 jinlin. All Rights Reserved. 金龄科技公司版权所有",
    1: {
      0: "友情链接：",
      1: "金龄科技",
      2: "中国老年大学协会",
      3: "中国老年学和老年医学学会",
      4: "历趣APP下载",
    },
    2: { 0: "备案号：", 1: "粤ICP备19021271号" },
  },
  modelList: [
    { title: "金龄科技公众号", img: require("@/images/wechat.jpg") },
    { title: "扫码添加客服微信", img: require("@/images/service.jpeg") },
    {
      title: "合作洽谈",
      img: require("@/images/cooperate.png"),
      number: "0755-2692 0484",
    },
    {},
  ],
};
